






















































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { Constructor } from 'vue/types/options';
import { favoriteFlags } from '@/agiles/common';

@Component
export default class ManagementReport extends Vue {
  public rptSalesAnalyse = Components.RptSalesAnalyse;
  public rptSalesSummary = Components.RptSalesSummary;
  public rptPurchaseSummary = Components.RptPurchaseSummary;
  public rptCommodityAnalyse = Components.RptCommodityAnalyse;
  public rptSalesDeliverySchedule = Components.RptSalesDeliverySchedule;
  public rptPurchaseDeliverySchedule = Components.RptPurchaseDeliverySchedule;
  public rptSalesJournal = Components.RptSalesJournal;
  public rptPurchaseJournal = Components.RptPurchaseJournal;
  public rptCommodityJournal = Components.RptCommodityJournal;
  public rptChargeJournal = Components.RptChargeJournal;
  public rptStockBalance = Components.RptStockBalance;
  public rptSupplementCommodity = Components.RptSupplementCommodity;
  public rptReceivePaymentScheduled = Components.RptReceivePaymentScheduled;
  public rptReceivePaymentResult = Components.RptReceivePaymentResult;
  public rptSendPaymentScheduled = Components.RptSendPaymentScheduled;
  public rptSendPaymentResult = Components.RptSendPaymentResult;
  public rptPurchaseCashBalance = Components.RptPurchaseCashBalance;
  public rptSalesCashBalance = Components.RptSalesCashBalance;  
  public rptSlipJournalItem = Components.RptSlipJournalItem;
  public rptTransactionSummary = Components.RptTransactionSummary;


  public reportNames = {
    RptSalesAnalyse : "売上分析表",
    RptSalesSummary: "売上集計表",
    RptPurchaseSummary: "仕入集計表",
    RptCommodityAnalyse: "商品分析表",
    RptSalesDeliverySchedule: "出荷予定表",
    RptPurchaseDeliverySchedule: "入荷予定表",
    RptSalesJournal: "売上元帳",
    RptPurchaseJournal: "仕入元帳",
    RptCommodityJournal: "商品元帳",
    RptChargeJournal: "諸掛元帳",
    RptStockBalance: "在庫一覧表",
    RptSupplementCommodity: "補充商品一覧表",
    RptReceivePaymentScheduled: "入金予定表",
    RptReceivePaymentResult: "入金実績表",
    RptSendPaymentScheduled: "支払予定表",
    RptSendPaymentResult: "支払実績表",
    RptPurchaseCashBalance: "買掛残高表",
    RptSalesCashBalance: "売掛残高表",  
    RptSlipJournalItem: "会計仕訳一覧表",
    RptTransactionSummary: "売上仕入集計表",    
  }
  //お気に入りロード時に型の復元が必要な場合に指定(プロパティ名:型)
  public binders = {
    reportTemplate: Common.ReportTemplate,
  }
  public mounted(){
    this.launchDialog();

  }
  public launchDialog(){
     if (this.$route.query.rpt != null && this.$route.query.favorite != null) {
       //コンポーネントのコンストラクタを取得
       var reportClass =  (<any>Components)[this.$route.query.rpt as string];
        this.$api.execute(new Common.FavoriteLoadQuery(this.$route.query.favorite as string)).then(res => {
                this.showReportDialog(reportClass,res);
        });       

     }
  }
  //ダイアログを表示する際にセット
  public instance: Components.ListDialog;
  public instanceClassName :string;
  public instanceFields: Array<string> = null;
  public instanceTitle: string = null;
  public favorite: Common.Favorite = null;  
  public favoriteLoaded:boolean = false;

  public showReportDialog(reportClass: any, favorite: Common.Favorite = null){
    var componentClass = Vue.extend(reportClass);
    this.instance = new componentClass({parent: this});
    for(var key in Components){
      if ((Components as any)[key]  == reportClass) this.instanceClassName = key;
    }
    
    this.favorite = favorite; //ボタン呼び出し時は追加モード(null)・お気に入りロード時は更新モード
    this.favoriteLoaded = favorite != null;

    //レポートダイアログのpublic fieldを抽出・保存
    var excludeFields = Object.getOwnPropertyNames(new Vue());
    excludeFields.push('onReportGenerate');
    excludeFields.push('tenantSetting');
    this.instanceFields = Object.getOwnPropertyNames(this.instance).filter(name => excludeFields.includes(name)==false);

    this.instance.$mount();
    this.instance.$on('hidden', () => {
      //destroyできない
      this.instance.$el.parentElement.removeChild(this.instance.$el);
      this.instance.$destroy();
    });
    this.$el.appendChild(this.instance.$el);

    //お気に入りの反映
    if (favorite){
      this.$nextTick(()=>{
        var source = JSON.parseWithDate(favorite.json);
        for(var key in this.binders){
          if (source[key]){
            source[key] = new Common.ModelBinder((this.binders as any)[key]).loadInstance(source[key]);
          }
        };
                  
        Object.assign(this.instance,source);
      });
    }
  }

  public formatTitle(title:string){
    return String.format('{0} - {1}',title,this.favoriteLoaded ? this.favorite.name :'抽出条件');
  }

  public favoriteName:string = null;
  public favoriteForTenant = false;
  public favoriteShowOnHome :boolean = false;

  public get hasTenantFavoritePermission(){
    return this.$api.perms.hasMenuPermission(Common.Favorite.perm);
  }
  public get favoriteDisabled(){
    return this.favoriteLoaded && this.favorite.isTenant && (this.$api.perms.hasMenuPermission(Common.Favorite.perm) == false);
  }  

  public showDialog = false;

  public onShowFavorite()
  {
    //表示区分を設定
    if (this.favorite){
      this.favoriteName = this.favorite.name;
      this.favoriteForTenant = this.favorite.isTenant;      
      this.favoriteShowOnHome = this.favorite.showOnHome;
    } else {
      this.favoriteName = null;
      this.favoriteForTenant = false;
      this.favoriteShowOnHome = false;      
    }

    this.$el.removeChild(this.instance.$el);//ダイアログを非表示
    this.showDialog = true;
  }
  public onOk(event: any){

    const name = (this.$refs.favoriteName as any) as Components.IControl;
    var validated1 = name.validator.validate();
    if (validated1 == false) {
      event.preventDefault();
      return;
    }

    if (this.favoriteLoaded == false) {
      this.favorite = new Common.Favorite();
      //新規追加時のみテナント表示区分をセットする
      this.favorite.owner = this.favoriteForTenant ? null :this.$api.auth.userId; //所有者
      this.favorite.shared = this.favoriteForTenant ? null :this.$api.auth.userId; //表示先=>テナント全体
    }

    this.favorite.name = this.favoriteName;
    this.favorite.showOnHome = this.favoriteShowOnHome;
    this.favorite.path = '/reports?rpt=' + this.instanceClassName;
    this.favorite.viewName = 'menu_reports';    

    var target = {};
    for(let field of this.instanceFields){
      (target as any)[field] = (this.instance as any)[field];
    }        
    this.favorite.json = JSON.stringify2(target);
    this.favorite.reportName = (this.reportNames as any)[this.instanceClassName];
    this.$api.update(this.favorite).then(res => {
      // this.$el.appendChild(this.instance.$el);//ダイアログを再表示
      this.instance.$destroy(); //ダイアログを再表示しない
    });
  }
  public onCancel(){
    this.$el.appendChild(this.instance.$el);//ダイアログを再表示    
  }

  public selectedFavorite:Common.Favorite = null;
  public moveToFavorite(){
    if(this.$route.fullPath == this.selectedFavorite.url) 
      this.launchDialog();
    else 
      this.$router.push(this.selectedFavorite.url);
  }
  
  public onDeleteFavorite(){
    this.$el.removeChild(this.instance.$el);//ダイアログを非表示    
    this.$api.modal.showDialog('確認',String.format('お気に入り「{0}」を削除してよろしいですか?',this.favorite.name),false).then(()=>{
      this.instance.$destroy();
      this.$api.remove(this.favorite);
      }).catch(()=>{
        this.$el.appendChild(this.instance.$el);//ダイアログを再表示
      });  
  }

}
